// @flow
import React, { useContext } from 'react';

import type {
  CMSProps,
  GQLProps,
} from 'Client/cms/toolkit/product-price-remote/productPriceRemote.resolver';
import { PriceRemoteStickyWrapper } from 'Components/widgets/price-remote/PriceRemoteStickyWrapper';
import ReactAppContext from 'Context/ReactAppContext';
import { addTranslationKeys } from 'Src/i18n';
import { isFeatureFlipped } from 'Utils/feature-flipping/featureFlippingUtils';

type Props = {|
  ...$Exact<CMSProps>,
  ...$Exact<GQLProps>,
|};

export function ProductPriceRemoteLine({ bookingCriteria, product, config }: Props) {
  const appContext = useContext(ReactAppContext);
  const isEnabled = isFeatureFlipped(appContext)('priceRemote.enabled');

  if (!product || !bookingCriteria || !isEnabled) {
    return null;
  }

  addTranslationKeys(config);

  const urgentisationRate = config.booking.priceCalendar.offers.urgentisation.rateToDisplay;

  return (
    <div className="Line Line-PriceRemote mb-16 lg:mb-10" data-testid="Line-ProductPriceRemote">
      <PriceRemoteStickyWrapper
        bookingCriteria={bookingCriteria}
        product={product}
        urgentisationRate={urgentisationRate}
      />
    </div>
  );
}
